import { Country } from '@tiendanube/common/src/enums';
import ShowByCountry from 'App/components/ShowByCountry';
import { NUVEMENVIO_BLACK_FRIDAY_BANNER } from 'App/featuresFlags';
import { useResponsive } from 'commons/components';
import { useDismissibleComponent, useWhatsappMessageLink } from 'commons/hooks';
import { openWindow } from 'commons/utils/window';
import { useGetTags } from 'domains/Auth/hooks';
import {
  trackingNuvemEnvioBlackFridayBannerClick,
  trackingNuvemEnvioBlackFridayBannerClose,
} from 'domains/NuvemEnvioCommons/tracking';
import BannerDesktop from '../BannerDesktop';
import BannerMobile from '../BannerMobile';

const WHATSAPP_MESSAGE = 'Oi! Quero Nuvem Envio para Black Friday';

const WHATSAPP_PHONE = '+5511963264784';

function BlackFridayBanner() {
  const { isMobile: isMobileResponsive } = useResponsive();
  const getUrl = useWhatsappMessageLink();
  const hasBlackFridayBanner = useGetTags().includes(
    NUVEMENVIO_BLACK_FRIDAY_BANNER,
  );
  const { shouldShow, dismiss } = useDismissibleComponent(
    'black-friday-banner-dismiss',
    90,
  );

  const handleClick = () => {
    trackingNuvemEnvioBlackFridayBannerClick();
    openWindow(
      getUrl({
        phone: WHATSAPP_PHONE,
        message: WHATSAPP_MESSAGE,
      }),
      true,
    );
  };

  const handleClose = () => {
    trackingNuvemEnvioBlackFridayBannerClose();
    dismiss();
  };

  if (!shouldShow || !hasBlackFridayBanner) {
    return null;
  }

  return (
    <ShowByCountry allowedCountries={[Country.BR]}>
      <>
        {isMobileResponsive && (
          <BannerMobile
            onClose={handleClose}
            onClick={handleClick}
            translateKey="blackFridayBanner"
          />
        )}
        {!isMobileResponsive && (
          <BannerDesktop
            onClose={handleClose}
            onClick={handleClick}
            translateKey="blackFridayBanner"
          />
        )}
      </>
    </ShowByCountry>
  );
}

export default BlackFridayBanner;
